'use client';

import type { StateAbbreviation } from '@repo/supergraph-schemas/marketplace/types';
import { Dropdown } from '../../Dropdown';
import { STATE_OPTIONS } from '../constants';
import { useGeo } from '../GeoProvider';
import { GeoDropdownSkeleton } from './Skeleton';

type GeoDropdownProps = {
  initialLocation: StateAbbreviation;
};

export function GeoDropdown({ initialLocation }: GeoDropdownProps) {
  const { isReady, regionCode, setRegionCode } = useGeo();

  return !isReady ? (
    <GeoDropdownSkeleton />
  ) : (
    <Dropdown
      id="geo-dropdown"
      value={regionCode ?? initialLocation}
      label="Show accounts available in"
      options={STATE_OPTIONS}
      onChange={value => {
        setRegionCode(value as StateAbbreviation);
      }}
    />
  );
}
